module.exports = __webpack_public_path__ + "img/20200512_161739.9c3ddb6b.jpg";